/**
 * Кнопка «назад» клиента Telegram на вложенном экране.
 *
 * Своей кнопки в интерфейсе нет намеренно: два механизма возврата на одном
 * экране путают. На вложенных экранах показывается системная.
 */
import { backButton } from '@telegram-apps/sdk-react';
import { useEffect, useRef } from 'react';

/**
 * @param active Показывать ли кнопку. На вкладках её быть не должно —
 *   уходить с них некуда, — но пока открыта шторка, она нужна: нажатие
 *   должно закрывать шторку, а не сворачивать приложение.
 */
export function useBackButton(onBack: () => void, active = true): void {
  // Обработчик держим в ref: иначе новая функция на каждый рендер
  // переподписывала бы кнопку и та мигала бы.
  const handler = useRef(onBack);
  handler.current = onBack;

  useEffect(() => {
    if (!active || !backButton.show.isAvailable()) {
      return;
    }
    backButton.show();
    const off = backButton.onClick(() => handler.current());

    return () => {
      off();
      if (backButton.hide.isAvailable()) {
        backButton.hide();
      }
    };
  }, [active]);
}
